// import {
//   setSectionSelected,
//   setCurrentSection,
//   setNewCurrentNode,
// } from '../../utilities';
// import {
//   PROTOCOL_SLIDE_TYPES,
//   SLIDE_NODE,
//   NOTEBOOK_SECTIONS,
//   SLIDE_GROUP,
// } from '@learningblocks/protocol-constants/lib/Utilities';

// set the simulation level. and load data for the particular level
export function setSimulationLevel(state, payload) {

  // return {
  //   ...state,
  //   showLevelModal: false,
  //   notebookCollapsed: false,
  //   levelData: payload.levelData,
  //   protocolSection,
  //   sections: setSectionSelected(setSections(payload.levelData), payload.levelData.COMPONENTS[0]),
  //   currentSection: setCurrentSection(payload.levelData, payload.levelData.COMPONENTS[0]),
  //   levelSelected: payload.levelId
  // };

  console.log(payload)
  const showLevelSelector = false;
  const sections = payload.levelData.MENU_LIST;
  const currentSection = getCurrentChapter(payload.levelData);
  const protocolSection = getProtocolChapter(payload.levelData.PROTOCOL_CHAPTER);
  const drawerCollapsed = false;
  const notebook = payload.levelData.GENERAL_CONFIG;
  const levelSelected = payload.levelId;
  const levelData = payload.levelData;

  return {
    showLevelSelector,
    sections,
    currentSection,
    protocolSection,
    drawerCollapsed,
    notebook,
    levelSelected,
    levelData,
    ...payload.levelData.GENERIC_CHAPTERS,
  };

}

/**
 * Function is to fetch the data for currentChapter to be displayed on the Notebook;
 * This is by default the CONTEXT chapter
 * Assumption for the function is that CONTEXT or any other chapter to be deemed as the current
 * will be initially in the payload.GENERIC_CHAPTERS section.
 */
function getCurrentChapter(payload) {
  console.log(payload)
  const currentMenuValue = payload.MENU_LIST.find((menu) => menu.current).value;
  return payload.GENERIC_CHAPTERS[currentMenuValue];
}

function getProtocolChapter({...props}) {
  return {
    ...props
  };
}
